import { toast } from 'sonner';

/**
 * Dit à l'avocat pourquoi la sortie est refusée et lui donne la seule issue :
 * afficher la dernière version. Recharger ne perd rien en silence : s'il reste
 * des frappes non enregistrées, `RedactionNavigationGuards` fait demander au
 * navigateur une confirmation avant de quitter la page.
 *
 * Le message reste affiché jusqu'à ce que l'avocat agisse : il n'y a rien à
 * réessayer, et un toast parti avant d'être lu laisserait l'avocat sans issue.
 */
export function annoncerVersionDepassee(sortie: 'Téléchargement impossible' | 'Enregistrement impossible'): void {
  toast.error(`${sortie} : ce document a été modifié depuis un autre onglet, et celui-ci affiche une version plus ancienne.`, {
    duration: Infinity,
    action: { label: 'Afficher la dernière version', onClick: () => window.location.reload() },
  });
}
